module.exports = new __parcel__URL__("life-buoy.285e728c.webp").toString();